/**
 * Menu tracking for navigation interactions
 * Tracks when various menu types are opened
 */

import { trackMenuOpened } from './events.js';

/**
 * Initialize menu tracking for all menu types
 */
export function initMenuTracking() {
    // Track navigation drawer openings (mobile menu, mega menu drawers)
    document.addEventListener('dialog:after-show', handleDialogShow);
    
    // Track mega menu and dropdown openings (desktop)
    document.addEventListener('toggle', handleToggleEvent, true);
}

/**
 * Handle dialog show events (navigation drawers, cart drawer, etc.)
 */
function handleDialogShow(event) {
    const element = event.target;
    
    // Only track navigation-related dialogs
    if (element.classList.contains('navigation-drawer')) {
        const menuType = getNavigationDrawerType(element);
        trackMenuOpened({
            menu_type: menuType,
            viewport_width: window.innerWidth,
            viewport_height: window.innerHeight
        });
    }
}

/**
 * Handle toggle events for details/summary elements (mega menus, dropdowns)
 */
function handleToggleEvent(event) {
    const element = event.target;
    
    // Only track when opening (not closing)
    if (!element.open) return;
    
    let menuType = 'unknown';
    
    if (element.matches('[is="mega-menu-disclosure"]')) {
        menuType = 'mega_menu_disclosure';
    } else if (element.matches('[is="dropdown-disclosure"]')) {
        menuType = 'dropdown_disclosure';
    } else if (element.closest('.navigation-drawer')) {
        // Dropdowns inside navigation drawer
        menuType = 'navigation_drawer_submenu';
    }
    
    if (menuType !== 'unknown') {
        trackMenuOpened({
            menu_type: menuType,
            viewport_width: window.innerWidth,
            viewport_height: window.innerHeight
        });
    }
}

/**
 * Determine the type of navigation drawer
 */
function getNavigationDrawerType(element) {
    const id = element.id;
    
    if (id === 'header-sidebar-menu') {
        return 'main_navigation_drawer';
    }
    
    if (element.closest('[data-mega-menu-drawer]')) {
        return 'mega_menu_drawer';
    }
    
    return 'navigation_drawer';
}